/**
 * @desc 订单详情
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: Array<string>, options?: any) {
  return updateResponse(
    http(URL + `/rpc/omsflow/getOrderItemDetails`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
